export const CUSTOMER_PORTAL_SESSION_KEY = "customerPortalSession";

/** @deprecated legacy flag; cleared on logout */
export const CUSTOMER_PORTAL_AUTH_KEY = "customerPortalAuthenticated";

export function initialsFromName(name) {
  if (!name || typeof name !== "string") return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function getCustomerPortalSession() {
  try {
    const raw = sessionStorage.getItem(CUSTOMER_PORTAL_SESSION_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.token || Number(data?.user?.role_id) !== 6) return null;
    return data;
  } catch {
    return null;
  }
}

export function setCustomerPortalSession(apiResponse) {
  const nameParts = (apiResponse.full_name || "").trim().split(/\s+/).filter(Boolean);
  const user = {
    id: apiResponse.id,
    full_name: apiResponse.full_name,
    first_name: apiResponse.first_name || nameParts[0] || "",
    last_name: apiResponse.last_name || nameParts.slice(1).join(" ") || "",
    email: apiResponse.email,
    phone_number: apiResponse.phone_number,
    country_code: apiResponse.country_code,
    role_id: apiResponse.role_id,
    salon_id: apiResponse.salon_id,
    profile_photo_url: apiResponse.profile_photo_url,
    customer_portal_settings: apiResponse.customer_portal_settings ?? null,
    cancellation_policy: apiResponse.cancellation_policy ?? null,
  };
  sessionStorage.setItem(
    CUSTOMER_PORTAL_SESSION_KEY,
    JSON.stringify({
      token: apiResponse.token,
      auth_key: apiResponse.auth_key,
      user,
    }),
  );
}

export function updateCustomerPortalUserProfile(profile) {
  const session = getCustomerPortalSession();
  if (!session?.token) return;

  setCustomerPortalSession({
    token: session.token,
    auth_key: session.auth_key,
    id: profile.id ?? session.user.id,
    full_name: profile.full_name ?? session.user.full_name,
    first_name: profile.first_name ?? session.user.first_name,
    last_name: profile.last_name ?? session.user.last_name,
    email: profile.email ?? session.user.email,
    phone_number: profile.phone_number ?? session.user.phone_number,
    country_code: profile.country_code ?? session.user.country_code,
    role_id: profile.role_id ?? session.user.role_id,
    salon_id: profile.salon_id ?? session.user.salon_id,
    profile_photo_url: profile.profile_photo_url ?? session.user.profile_photo_url,
    customer_portal_settings: profile.customer_portal_settings ?? session.user.customer_portal_settings ?? null,
    cancellation_policy: profile.cancellation_policy ?? session.user.cancellation_policy ?? null,
  });
}

export function updateCustomerPortalSettingsInSession(settings) {
  const session = getCustomerPortalSession();
  if (!session?.token) return;

  sessionStorage.setItem(
    CUSTOMER_PORTAL_SESSION_KEY,
    JSON.stringify({
      ...session,
      user: {
        ...session.user,
        customer_portal_settings: settings,
      },
    }),
  );
}

export function clearCustomerPortalSession() {
  sessionStorage.removeItem(CUSTOMER_PORTAL_SESSION_KEY);
  sessionStorage.removeItem(CUSTOMER_PORTAL_AUTH_KEY);
}
